import { IncidentStepsContent } from './EpIncidentStepsContent';

export const EpIncidentSteps = ({
  isPublicTemplate = false,
}: {
  isPublicTemplate?: boolean;
}) => {
  return <IncidentStepsContent isPublicTemplate={isPublicTemplate} />;
};
